import { Component, HostListener } from '@angular/core';
import { InactivityTimerService } from './core/services/inactivity-timer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
    public Title : string = 'MemberResponsePortal';

    constructor(private inactivityTimerService: InactivityTimerService){
    }

    //#region Event Handlers
    @HostListener('window:beforeunload', ['$event'])
    private HandleBeforeUnload(event : BeforeUnloadEvent) : void{
        event.preventDefault();
    }

    @HostListener('document:mousemove')
    @HostListener('document:click')
    @HostListener('document:keydown')
    private OnUserInteraction(): void {
        this.inactivityTimerService.ResetTimerOnActivity();
    }
    //#endregion  Event Handlers
}
